var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Move element up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-up",
    "data-name": "Icon ionic-md-arrow-round-up",
    d: "M84.071,39.066,51.776,7.671a7.576,7.576,0,0,0-5.4-2.046h-.1a7.576,7.576,0,0,0-5.4,2.046L8.589,39.066a6.466,6.466,0,0,0,0,9.821,8.325,8.325,0,0,0,10.893,0L38.618,30.018v48.65c0,3.842,3.446,6.957,7.712,6.957,4.338,0,7.712-3.115,7.712-6.957V30.018L73.177,48.887a8.325,8.325,0,0,0,10.893,0A6.466,6.466,0,0,0,84.071,39.066Z",
    transform: "translate(-6.33 -5.625)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRound);
export default __webpack_public_path__ + "static/media/arrowUpRound.0e1c4fd44550c78c13c414e0d7ae7d2f.svg";
export { ForwardRef as ReactComponent };